/* import __COLOCATED_TEMPLATE__ from './table-cell-messages-link.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();